<div id="mask" class="" style="display: block; opacity: 0.8"></div>
<div
  id="first_window"
  class="modalWindow"
  style="top: 50%; left: 50%; display: block; position: fixed; transform: translate(-50%, -50%)"
  [ngClass]="IsSemiAnonymous ? 'semi-anonymous-modal' : 'anonymous-modal'"
>
  <div class="modal-header clearfix">
    <div class="width100 bold-txt">
      <span [innerHTML]="Header"></span>
      <div
        style="position: absolute; top: 8px; right: -5px"
        class="fr txt-right close-icon close_modal"
        (click)="Close()"
        tabindex="0"
        aria-label="Close"
        role="button"
        (keydown)="CloseKeyboard($event)"
      ></div>
    </div>
  </div>
  <!-- If SemiAnonymous Set Message -->
  <div *ngIf="IsSemiAnonymous" [innerHTML]="Message"></div>
  <!-- Else for Anonymous Message -->
  <div *ngIf="!IsSemiAnonymous">
    <div class="modal-body" [ngStyle]="{ 'text-align': isRTL ? 'right' : 'left' }">
      <p class="head-space txt-center bold-txt">{{ Message[0]["desc"] }}</p>
      <div class="clearfix">
        <div class="fl bot-padding width40 txt-center" style="width: 40%">
          <img
            alt="Survey Icon"
            src="../../survey/assets/ImagesNew/PM/an_survey_icon.png"
            width="90%"
            style="max-width: 200px"
          />
        </div>
        <div class="fr width-big">
          <div *ngFor="let item of Message | slice: 1 : 3; let i = index">
            <p
              class="bold-txt"
              [ngClass]="{ 'fq-space': i == 0, 'q-space': i > 0 }"
              [innerHTML]="item.header"
            ></p>
            <p [innerHTML]="item.desc"></p>
          </div>
        </div>
      </div>
      <div *ngFor="let item of Message | slice: 3 : 5; let i = index">
        <p
          class="bold-txt"
          [ngClass]="{ 'fq-space': i == 0, 'q-space': i > 0 }"
          [innerHTML]="item.header"
        ></p>
        <p [innerHTML]="item.desc"></p>
      </div>
    </div>
  </div>
</div>
